import * as Sentry from '@sentry/nextjs';

import { ensureData } from '@/lib/data/utils';

const DISABLE_SENTRY =
  process.env.DISABLE_SENTRY === 'true' ||
  process.env.NEXT_PUBLIC_DISABLE_SENTRY === 'true';

function captureException(exception) {
  return (errorContext) => Sentry.captureException(exception, errorContext);
}

function captureMessage(errorMessage) {
  return (errorContext) => Sentry.captureMessage(errorMessage, errorContext);
}

export function trackError(
  sessionOrSessionData,
  errorKind,
  exception,
  metadata
) {
  const sessionData = ensureData(sessionOrSessionData);

  let eventId;

  if (!DISABLE_SENTRY) {
    eventId = (
      exception instanceof Error
        ? captureException(exception)
        : captureMessage(errorKind)
    )({
      tags: { ...metadata, errorKind },
      fingerprint: errorKind,
      user: sessionData?.user?.username,
    });

    console.log(`Sentry event ID: ${eventId}`);
  }

  if (exception instanceof Error) {
    console.error(exception);
  } else {
    console.log(['error', exception, metadata, sessionData]);
  }

  return eventId;
}
